import {
    apiRequest,
    PromotionPeriodList,
    PromotionPeriodApprove,
    PromotionPeriodDelete
} from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", PromotionPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    
    fetchCreate = async (query) => {
        return await apiRequest("post", PromotionPeriodApprove, {
            body: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", PromotionPeriodDelete, {
            body: query
        }, true)
    }

}

export default DataTableRepository